import { FloatingBarDeleteController } from './floating-bar-delete.controller'

function floatingBarDelete () {
  return {
    restrict: 'E',
    scope: {
      selectedItems: '<',
      totalLength: '<',
      onSelectAll: '<',
      onUnSelectAll: '<',
      onDelete: '<'
    },
    templateUrl: '/core/directives/floating-bar-delete/floating-bar-delete.html?$$REVISION$$',
    controller: FloatingBarDeleteController
  }
}

export { floatingBarDelete }
